<template>
  <div class="bg-white border border-gray-300 rounded-xl shadow-2xl w-80 max-w-[90vw]">
    <div class="flex justify-between items-center p-4 bg-green-500 text-white rounded-t-xl">
      <div class="flex gap-2 items-center">
        <img class="lg:mt-2 w-[30px] md:h-[35px] md:w-[36px] lg:h-[32px] lg:w-[31px] ml-0"
          src="@/assets/img/common/logo.svg" alt="Logo BCompliance" />
        <div>
          <div class="router-link-active">BCompliance&amp;Law</div>
          <div class="text-sm opacity-80 text-left text-[10px]">Online</div>
        </div>
      </div>
      <button @click="$emit('close')" aria-label="Fechar chat">✕</button>
    </div>
    <div class="text-left text-sm p-4 text-sm text-gray-700">
      <p class="mb-3 font-bold">Olá, vamos conversar pelo whatsapp?</p>
      <p class="mb-3">
        Para agilizar seu atendimento, preencha os campos abaixo e clique em
        iniciar conversa. 😀
      </p>

      <input v-model="name" placeholder="Nome*"
        class="w-full mb-2 p-2 border rounded resize-none focus:outline-none focus:ring focus:ring-green-400 border-b border-b-[#8CBAFF]" />

      <div class="flex">
        <div>
          <CountriesPhoneCode v-model="countryCode" />
        </div>
        <div class="grow">
          <InputComponent class="pl-2 pt-2" @input="formatPhone" v-model="phone" max="15" type="text" :whats-app="true"
            placeholder="Telefone*" hint="Insira um telefone válido (DDD + Número). Exp: 15998341602" name="tel"
            autocomplete="tel" :required="true" />
        </div>
      </div>

      <input v-model="email" placeholder="E-mail"
        class="w-full mb-2 p-2 border rounded resize-none focus:outline-none focus:ring focus:ring-green-400 border-b border-b-[#8CBAFF]" />

      <div class="text-[9px] text-gray-500">
        <p class="text-xs text-gray-500">
          * Campos obrigatórios
        </p>
      </div>

      <button 
        @click="sendMessage" 
        :disabled="isSending" 
        class="mt-3 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 w-full disabled:opacity-50 disabled:cursor-not-allowed">
        <span v-if="!isSending">Enviar mensagem no WhatsApp</span>
        <span v-else>
          <svg class="animate-spin h-5 w-5 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
          </svg>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import CountriesPhoneCode from "@/components/CountriesPhoneCode.vue";
import InputComponent from "@/components/InputComponent.vue";
import { useWhatsAppChat } from "@/composables/useWhatsAppChat";

export default {
  name: 'WhatsAppForm',
  components: {
    CountriesPhoneCode,
    InputComponent,
  },
  emits: ['close'],
  setup() {
    const {
      name,
      phone,
      email,
      countryCode,
      isSending,
      formatPhone,
      sendMessage,
    } = useWhatsAppChat();

    return {
      name,
      phone,
      email,
      countryCode,
      isSending,
      formatPhone,
      sendMessage,
    };
  },
};
</script>